import { createBrowserRouter } from "react-router-dom";
import { EmptyState } from "./components";
import { LoginPage } from "./features/auth/LoginPage";
import { ProtectedLayout } from "./features/auth/ProtectedLayout";
import type { RouteHandle } from "./features/auth/ProtectedLayout";
import { DashboardPage } from "./features/dashboard/DashboardPage";
import { SuppliersPage } from "./features/catalogue/SuppliersPage";
import { BrandsPage } from "./features/catalogue/BrandsPage";
import { RateCardsPage } from "./features/catalogue/RateCardsPage";
import { DiscountsPage } from "./features/catalogue/DiscountsPage";
import { ProjectsPage } from "./features/projects/ProjectsPage";
import { ProjectDetailPage } from "./features/projects/ProjectDetailPage";
import { PricingDetailPage } from "./features/projects/PricingDetailPage";
import { PriceListsPage } from "./features/priceLists/PriceListsPage";
import { PriceListDetailPage } from "./features/priceLists/PriceListDetailPage";
import { ProductsPage } from "./features/products/ProductsPage";
import { ComparablesPage } from "./features/comparables/ComparablesPage";
import { ActivityPage } from "./features/system/ActivityPage";
import { AiUsagePage } from "./features/system/AiUsagePage";
import { AboutPage } from "./features/system/AboutPage";
import { UsersPage } from "./features/system/UsersPage";

const handle = (title: string): RouteHandle => ({ title });

export const router = createBrowserRouter([
  { path: "/login", element: <LoginPage /> },
  {
    element: <ProtectedLayout />,
    children: [
      { path: "/", element: <DashboardPage />, handle: handle("Dashboard") },
      { path: "/projects", element: <ProjectsPage />, handle: handle("Projects") },
      { path: "/projects/:id", element: <ProjectDetailPage />, handle: handle("Project") },
      { path: "/pricings/:id", element: <PricingDetailPage />, handle: handle("Pricing") },
      { path: "/suppliers", element: <SuppliersPage />, handle: handle("Suppliers") },
      { path: "/brands", element: <BrandsPage />, handle: handle("Brands") },
      { path: "/rate-cards", element: <RateCardsPage />, handle: handle("Rate cards") },
      { path: "/discounts", element: <DiscountsPage />, handle: handle("Discounts") },
      { path: "/products", element: <ProductsPage />, handle: handle("Products") },
      { path: "/price-lists", element: <PriceListsPage />, handle: handle("Price lists") },
      { path: "/price-lists/:id", element: <PriceListDetailPage />, handle: handle("Price list") },
      { path: "/comparables", element: <ComparablesPage />, handle: handle("Comparables") },
      { path: "/activity", element: <ActivityPage />, handle: handle("Activity") },
      { path: "/ai-usage", element: <AiUsagePage />, handle: handle("AI usage") },
      { path: "/users", element: <UsersPage />, handle: handle("Users") },
      { path: "/about", element: <AboutPage />, handle: handle("About") },
      {
        path: "*",
        handle: handle("Not found"),
        element: (
          <EmptyState
            title="Page not found"
            hint="The address doesn't match any screen — use the sidebar."
          />
        ),
      },
    ],
  },
]);
